import{useRef as e}from"react";import{useIsomorphicLayoutEffect as o}from"../useIsomorphicLayoutEffect/index.js";function t(){const r=e(!1);return o(()=>(r.current=!0,()=>{r.current=!1}),[]),r}export{t as useIsMounted};
//# sourceMappingURL=index.js.map
